import Terminal from "./components/Terminal";

function App() {
  return (
    <div className="App">
      <div className="min-h-screen p-4 text-xs md:text-sm flex justify-center items-center bg-gradient-to-r from-violet-700 via-cyan-700 to-blue-700
       ">
        <Terminal />
      </div>
    </div>
  );
}

export default App;
